import { ITEM_STATE_TO_BAG_IN_PROGRESS } from "../../constants";

export default ({ itemState }) => itemState === ITEM_STATE_TO_BAG_IN_PROGRESS;
